import { useEffect } from 'react';

import usePhoneFromBrazeId from './use-phone-from-braze-id';

interface ICompletePhoneFromBrazeIdProps {
  setFieldValue(field: string, value: any, shouldValidate?: boolean): void;
}

const CompletePhoneFromBrazeId = ({ setFieldValue }: ICompletePhoneFromBrazeIdProps) => {
  const phoneNumber = usePhoneFromBrazeId();

  useEffect(() => {
    if (phoneNumber) {
      setFieldValue('phoneNumber', phoneNumber);
    }
  }, [phoneNumber, setFieldValue]);

  return null;
};

export default CompletePhoneFromBrazeId;
